import lazyLoading from './lazyLoading'

export default {
  name: 'dashboard',
  path: '/dashboard',
  // component: lazyLoading('monitor/leaflet-maps/LeafletMapsPage'),
  component: lazyLoading('dashboard/Dashboard'),
  meta: {
    default: false,
    title: 'menu.dashboard',
    iconClass: 'fa fa-dashboard',
    requiresAuth: true
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/dashboard.js